//SelectEventTypesDialog
//***********************************************************************************************************************
import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog, IDialogButton } from "../framework/dialog";
import { EventTypeNode, IEventTypeNode } from "../../models/event/eventTypeNode";
import { DialogButtonType } from "ui/Scripts/source/models/enums";

//SelectEventTypesDialogLine
export interface ISelectEventTypesDialogLineProp {
    classes?: string;
    item: IEventTypeNode;
    level: number;
    parentActiveState: number;
    expandedNodeIds: string[];
    checkedIds: string[];
    onNodeClick: (id: string) => void;
    onCheckboxChange: (id: string, checked: boolean) => void;
}

export class SelectEventTypesDialogLine extends React.Component<ISelectEventTypesDialogLineProp, {}> {
    handleNodeClick = (e) => {
        this.props.onNodeClick(this.props.item.id);
    };

    handleCheckBoxClick = (e) => {
        e.stopPropagation();
        const props = this.props;
        this.props.onCheckboxChange(props.item.id, props.checkedIds.indexOf(props.item.id) < 0);
    };

    render() {
        const props = this.props;
        const item = props.item;
        const hasChildren = item.children.length > 0;
        const activeState = props.parentActiveState > 0 ? item.activeState : 0;
        const isExpanded = props.expandedNodeIds && props.expandedNodeIds.indexOf(item.id) > -1;
        return (
            <ul>
                <li className={"" + (!hasChildren ? " noChilds" : "") + (props.level < 1 ? " root" : "") + (activeState < 1 || item.disabled ? " disabled" : "") + (isExpanded ? " expanded" : "")} onClick={this.handleNodeClick}>
                    <span className={"node" + (!hasChildren ? " empty" : "")}></span>
                    <span className="name"><input type="checkbox" className="large" checked={props.checkedIds.indexOf(item.id) > -1} onClick={this.handleCheckBoxClick} onChange={() => {}} value="" />{item.code}</span>
                </li>
                {item.children.map(child => (
                    <SelectEventTypesDialogLine
                        key={child.id}
                        item={child}
                        level={props.level + 1}
                        parentActiveState={activeState}
                        expandedNodeIds={props.expandedNodeIds}
                        checkedIds={props.checkedIds}
                        onNodeClick={props.onNodeClick}
                        onCheckboxChange={props.onCheckboxChange}
                    />
                ))}
            </ul>
        );
    }
}

//SelectEventTypesDialog
export interface ISelectEventTypesDialogProp {
    classes?: string;
    nextPreviousMode?: boolean;
    eventTypeNodes: IEventTypeNode[];
    checkedIds: string[];
    title: string;
    onOk: (ids: string[]) => void;
    onCancel: () => void;
    onPrevious?: () => void;
}

export interface ISelectEventTypesDialogState {
    eventTypeNodes: IEventTypeNode[];
    expandedNodeIds: string[];
    checkedIds: string[];
}

export class SelectEventTypesDialog extends React.Component<ISelectEventTypesDialogProp, ISelectEventTypesDialogState> {
    constructor(props) {
        super(props);
        const eventTypeNodes = EventTypeNode.getActiveEventTypeNodes(props.eventTypeNodes, props.checkedIds);
        let expandedNodeIds: string[] = [];
        for (let i = 0; i < eventTypeNodes.length; i++) {
            for (let j = 0; j < props.checkedIds.length; j++) {
                const parentIdPath = eventTypeNodes[i].getParentIdPathToId(props.checkedIds[j]);
                if (!parentIdPath || parentIdPath.length < 1) continue;
                expandedNodeIds = Base.getUniqueStringItems(expandedNodeIds.concat(parentIdPath));
            }
        }
        this.state = { eventTypeNodes, expandedNodeIds, checkedIds: props.checkedIds.slice(0), };
    }

    handleNodeClick = (id: string) => {
        if (!id) return;
        const expandedNodeIds = this.state.expandedNodeIds.slice(0);
        if (expandedNodeIds.indexOf(id) < 0) {
            expandedNodeIds.push(id);
        } else {
            const node = EventTypeNode.getEventTypeNodeFromNodesById(this.state.eventTypeNodes, id);
            if (node) {
                const childIdPath = node.getChildIdPath();
                for (let i = 0; i < childIdPath.length; i++) {
                    const index = expandedNodeIds.indexOf(childIdPath[i]);
                    if (index < 0) continue;
                    expandedNodeIds.splice(index, 1);
                }
            }
        }
        this.setState({
            expandedNodeIds
        });
    };

    handleCheckboxChange = (id: string, checked: boolean) => {
        if (!id) return;
        let checkedIds = this.state.checkedIds.filter(i => i !== id);
        const node = EventTypeNode.getEventTypeNodeFromNodesById(this.state.eventTypeNodes, id);
        if (!node) return;
        if (checked) {
            checkedIds = Base.getUniqueStringItems(checkedIds.concat(node.getParentIdPath()));
        } else {
            const removeIds = node.getChildIdPath();
            for (let i = 0; i < removeIds.length; i++) {
                const index = checkedIds.indexOf(removeIds[i]);
                if (index < 0) continue;
                checkedIds.splice(index, 1);
            }
        }
        this.setState({
            checkedIds
        });
    };

    render() {
        const props = this.props;
        const state = this.state;
        const dialogClasses = "selectEventTypesDialog" + (props.classes ? " " + props.classes : "");
        const buttons: IDialogButton[] = [];
        if (props.nextPreviousMode) {
            if (props.onPrevious) {
                buttons.push({ title: Translations.Previous, buttonType: DialogButtonType.Default, onClick: props.onPrevious });
            }
            if (props.onOk) {
                buttons.push({ title: Translations.Next, buttonType: DialogButtonType.Default, onClick: () => { props.onOk(state.checkedIds); } });
            }
        } else {
            buttons.push({ title: Translations.OK, buttonType: DialogButtonType.Default, onClick: () => { props.onOk(state.checkedIds); } });
            buttons.push({ title: Translations.Cancel, buttonType: DialogButtonType.Default, onClick: props.onCancel });
        }
        return (
            <Dialog
                classes={dialogClasses}
                title={props.title}
                body={
                    <div className="largeDialogContent">
                        <div className="nodeTree eventTypeTree">
                            {state.eventTypeNodes.map(eventTypeNode => (
                                <SelectEventTypesDialogLine
                                    key={eventTypeNode.id}
                                    item={eventTypeNode}
                                    level={0}
                                    parentActiveState={1}
                                    expandedNodeIds={state.expandedNodeIds}
                                    checkedIds={state.checkedIds}
                                    onNodeClick={this.handleNodeClick}
                                    onCheckboxChange={this.handleCheckboxChange}
                                />
                            ))}
                        </div>
                    </div>
                }
                buttons={buttons}
                onClose={props.onCancel}/>
        );
    }
}